module.exports = __webpack_public_path__ + "static/serenity_forge-cc93fce1d1c003952a5418dbbd086880.png";